import fetch from "node-fetch";
import servicesUtils from "@/services/servicesUtils";
import { API_URL } from "@/services/db";

export const templateService = {
  getTemplateNames: async function () {
    try {
      const url = `${API_URL}/templates`;
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      console.log(e);
    }
  },
  getTemplate: async function (id) {
    if (!id) {
      return;
    }
    try {
      const url = `${API_URL}/templates/${id}`;
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      console.log(e);
    }
  },
  createTemplate: async function (payload) {
    try {
      const url = `${API_URL}/templates`;
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      console.error(e);
    }
  },
  updateTemplate: async function (id, payload) {
    if (!id) {
      return;
    }
    try {
      const url = `${API_URL}/templates/${id}`;
      const res = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      return servicesUtils.checkStatus(res);
    } catch (e) {
      console.error(e);
    }
  },
  generateText: async function (examId, options = {}) {
    if (!examId) {
      return;
    }
    try {
      const url = `${API_URL}/templates/generate/${examId}`;
      const payload = {};
      if (options.templateMasterId !== undefined && options.templateMasterId !== null) {
        payload.templateMasterId = options.templateMasterId;
      }
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      console.error(e);
    }
  },
  getFindingTemplateMappings: async function (params = {}) {
    const {
      interventionId,
      templatePurpose,
      templateMasterId,
    } = params || {};

    const query = new URLSearchParams();
    if (interventionId !== undefined && interventionId !== null) {
      query.append('intervention_id', interventionId);
    }
    if (templatePurpose) {
      query.append('template_purpose', templatePurpose);
    }
    if (templateMasterId !== undefined && templateMasterId !== null) {
      query.append('template_master_id', templateMasterId);
    }

    const queryString = query.toString();
    const url = `${API_URL}/templates/mappings${queryString ? `?${queryString}` : ''}`;

    try {
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      console.error(e);
    }
  },
}
